import { render, staticRenderFns } from "./CartButton.vue?vue&type=template&id=0456cc76&scoped=true"
import script from "./CartButton.vue?vue&type=script&lang=ts"
export * from "./CartButton.vue?vue&type=script&lang=ts"
import style0 from "./CartButton.vue?vue&type=style&index=0&id=0456cc76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0456cc76",
  null
  
)

export default component.exports